import type { Field } from '@/modules/Project/Fields/types'
import { getFieldReadonly } from '@/modules/Project/Fields/utils/readonly'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'

/**
 * Returns true if and only if the field can have its value updated. Takes
 * into account:
 * - User permissions
 * - Whether the field has been marked as ground truth
 * - Whether recalculation is blocked because the field is immutable
 *
 * And any other factors that might affect whether the field can have its value updated.
 */
export const useIsReadonly = (field: MaybeRefOrGetter<Field | undefined>) => {
  return computed(() => {
    const fieldValue = toValue(field)
    if (!fieldValue) return true

    return getFieldReadonly(fieldValue)
  })
}
